<template>
    <div class="panel">
        <h3>User data</h3>

        <div>
            <Checkbox v-model="data.isAuthenticated" density="compact">
                Authenticated user
            </Checkbox>
            <Checkbox v-model="data.isVerified" density="compact"> Verified user </Checkbox>
        </div>
    </div>

    <div class="panel">
        <h3>Page data</h3>

        <div class="panel-count">
            <div class="panel-count-row">
                Bookings
                <Count :min="0" :max="20" buttonSize="s" v-model="data.count" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { FakeDataBookings } from '../DevPanel.interfaces';
    import Checkbox from '@ui/components/FormV2/Fields/Checkbox/Checkbox.vue';
    import Count from '@ui/components/FormV2/Fields/Count/Count.vue';

    export default defineComponent({
        name: 'BookingsPanel',
        components: { Checkbox, Count },
        props: {
            data: {
                type: Object as PropType<FakeDataBookings>,
                required: true,
            },
        },
    });
</script>

<style lang="scss">
    @forward './Panel.scss';
</style>
